import * as React from 'react';

import {Form, Formik, FormikProps} from 'formik';

import {animateScroll as scroll, scroller} from 'react-scroll';

import PetMemorialModal from '@app/components/UI/PetMemorialModal/PetMemorialModal';

import PetMemorialCard from '@app/components/Pages/PetMemorial/PetMemorialCard';
import {PetMemorialBlockProps, PetModalProps} from '@app/objects/PetMemorial';
import SearchFieldAuto from '@app/components/Forms/SearchField/SearchFieldAuto';
import {dateConvert} from '@app/components/Pages/PetMemorial/utils/dateConvert';
import {bodyOverflowRemove, bodyOverflowTransform} from '@app/components/LocalCommon/Utils/bodyOverflowTransform';
import '@app/scss/components/petMemorialBlock.scss';

const PetMemorialBlock: React.FC<PetMemorialBlockProps> = (props) => {
	const [modalVisible, setModalVisible] = React.useState(false);
	const [petName, setPetName] = React.useState('');
	const [ownerName, setOwnerName] = React.useState('');
	const [sent, setSent] = React.useState(false);

	const [modalProps, setModalProps] = React.useState<PetModalProps>({
		memorial: {
			petName: '',
			birthday: 0,
			dateCreated: 0,
			dateOfPassing: 0,
			message: '',
			story: '',
			firstName: '',
			lastName: '',
			city: '',
			state: '',
			id: 0,
			images: [],
			testimonial: undefined,
			memorialCandles: []
		}, dateBirth: '', datePass: '', datePost: {month: '', day: 0, year: 0}});

	const addCards = () => {
		props.loadMemorials(petName, ownerName, false);
	};

	React.useEffect(() => {
		window.scrollTo(0, 0);
		bodyOverflowTransform(true);
		return function cleanOverflow() {
			bodyOverflowRemove();
		};
	}, []);

	React.useEffect(() => {
		props.loadMemorials(petName, ownerName, true);
	}, [petName, ownerName]);

	return (
		<div className="pet-memorial-body__wrapper">
			<div className="pet-memorial-body">
				<div className="pet-memorial-body__nav">
					<Formik
						onSubmit={(values) => {
							setPetName(values['petName']);
							setOwnerName(values['ownerName']);
						}}
						initialValues={{
							petName: '',
							ownerName: ''
						}}

						render={(formikBag: FormikProps<any>) => {
							return(
								<Form>
									<SearchFieldAuto
										name="petName"
										placeholder="Search memorials by pet name"
										formikBag={formikBag}
										onChange = {(value, option) => {
											formikBag.setFieldValue('petName', value);
										}}
										searchButton={true}
										buttonType="submit"
									/>
									<SearchFieldAuto
										name="ownerName"
										placeholder="Search memorials by owner name"
										formikBag={formikBag}
										onChange = {(value, option) => {
											formikBag.setFieldValue('ownerName', value);
										}}
										searchButton={true}
										buttonType="submit"
									/>
								</Form>
							);
						}}
					/>
				</div>
				<div className="pet-memorial-body__content ">
					{
						props.resMemorials.map((memorial, index) => (
							<PetMemorialCard
								memorial={memorial}
								key ={memorial.id}
								setModalVisible = {setModalVisible}
							/>
						))
					}
				</div>
				{   props.resMemorials.length < props.totalCount &&
					<button className="btn btn-lg btn-secondary btn-load-more" onClick={addCards}>
						Load more memorials
					</button>
				}
			</div>
			<PetMemorialModal
				modalVisible={modalVisible}
				setModalVisible={setModalVisible}
				outerModalProps={props.resMemorials}
				sent={sent}
				setSent={setSent}
				currentMemorialId={props.currentMemorialId}
			/>
		</div>
	);
};

export default  PetMemorialBlock;
